import { render } from "./edittransfer.vue?vue&type=template&id=35675e72"
import script from "./edittransfer.vue?vue&type=script&lang=js"
export * from "./edittransfer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-POP-PROD\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__